interface HamburgerMenuProps {
	fill?: string;
}

export default function HamburgerMenu({ fill = '#000' }: HamburgerMenuProps) {
	return (
		<svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
			<g fill={fill}>
				<path d="m2 4h28v-1h-28z" />
				<path d="m10.9474 22.15v6.0427h4.5147v-.8726h-3.42v-1.8546h3.0736v-.7837h-3.0736v-1.6592h3.349v-.8726z" />
				<path d="m17.4439 22.15v6.0427h1.0058v-4.2462h.2512l2.6383 4.2462h1.1613v-6.0427h-1.0058v4.2551h-.2511l-2.6472-4.2551z" />
				<path d="m24.7401 22.15v3.7942c0 .8385.2277 1.4297.6553 1.8062.4348.3828 1.0594.5844 1.8952.5844.8228 0 1.4469-.2026 1.8914-.5894.4365-.38.668-.9699.668-1.8012v-3.7942h-1.0947v3.7942c0 .4887-.0968.8794-.3202 1.1411-.2328.2729-.6328.3858-1.1445.3858-.296 0-.5472-.0412-.7438-.1344-.187-.0886-.3396-.2067-.4514-.3569-.1095-.1471-.1805-.3156-.2139-.5029-.0312-.1747-.0468-.3523-.0468-.5327v-3.7942z" />
				<path d="m2.14996 22.15v6.0427h1.00584v-4.4505h.27426l1.55457 4.4505h.86154l1.55458-4.4949h.2746v4.4949h1.00584v-6.0427h-1.70389l-1.40356 4.3617h-.23449l-1.48351-4.3617z" />
				<path d="m30 10h-28v-1h28z" />
				<path d="m2 16h28v-1h-28z" />
			</g>
		</svg>
	);
}
